import fetch from "lib/fetch";
import type { CollaboratorInterface, CompanyLimitInterface } from "types/collaborator";

interface ListResponse<T> {
    data: Array<T>;
    pager: {
        total: number;
        total_page: number;
        last_page: number;
        per_page: number;
        current_page: number;
        order?: string;
        direction?: string;
        custom?: HashMap<number | undefined>;
    };
    filters: HashMap<unknown>;
}

type CollaboratorResponse = { data: CollaboratorInterface };
type CompanyLimitResponse = { data: CompanyLimitInterface };

export const getCollaboratorsRequest = (params?: HashMap<unknown>) =>
    fetch.get<ListResponse<CollaboratorInterface>>("collaborators", { params });

export const getCollaboratorRequest = (id: string) =>
    fetch.get<CollaboratorResponse>(`collaborators/${id}`);

export const updateCollaboratorRequest = (id: string, data: HashMap<unknown>) =>
    fetch.put<CollaboratorResponse>(`collaborators/${id}`, data);

export const getCollaboratorCompanyLimitRequest = (id: string) =>
    fetch.get<CompanyLimitResponse>(`collaborators/company_limit_use/${id}`);
